module.exports = __webpack_public_path__ + "static/media/logo.edad0130.svg";